const pageNameKey = "filteredNodeOurNode";

export const filteredNodeOurNodeEn = {
  [pageNameKey]: {
    structureIconText: "Show item in structure",
  },
};

export const filteredNodeOurNodePtBr = {
  [pageNameKey]: {
    structureIconText: "Mostrar item na estrutura",
  },
};

export const filteredNodeOurNodeDe = {
  [pageNameKey]: {
    structureIconText: "Element in Struktur anzeigen",
  },
};

export const filteredNodeOurNodeZhHans = {
  [pageNameKey]: {
    structureIconText: "在结构中显示项目",
  },
};

export const filteredNodeOurNodeIt = {
  [pageNameKey]: {
    structureIconText: "Vai al nodo nella struttura",
  },
};

export const filteredNodeOurNodeEs = {
  [pageNameKey]: {
    structureIconText: "Mostrar elemento en la estructura",
  },
};

export const filteredNodeOurNodeNl = {
  [pageNameKey]: {
    structureIconText: "Item weergeven in structuur",
  },
};

export const filteredNodeOurNodeTr = {
  [pageNameKey]: {
    structureIconText: "Öğeyi yapıda göster",
  },
};
